export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 30,
  baseUrl: {
    dev: '',
    // dev:    'http://192.168.0.162:8081',
    // dev: 'https://visitor.quantadata.com.cn',
    pro: ''
  }
};
